import { toast } from "react-toastify";
import api from "../../api/api";
import {
    FETCH_PAYMENTS_REQUEST,
    FETCH_PAYMENTS_SUCCESS,
    FETCH_PAYMENTS_FAILURE,
    FETCH_MY_PAYMENTS_REQUEST,
    FETCH_MY_PAYMENTS_SUCCESS,
    FETCH_MY_PAYMENTS_FAILURE,
    INITIATE_PAYMENT_REQUEST,
    INITIATE_PAYMENT_SUCCESS,
    INITIATE_PAYMENT_FAILURE,
} from "../actions/paymentActionTypes";



// Fetch Payments (Admin side)
export const fetchAllPayments = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENTS_REQUEST });

  try {

    const response = await api.get("/PaymentDetail/get-all");
    dispatch({
      type: FETCH_PAYMENTS_SUCCESS,
      payload: response.data,
    });

    // toast.success("Payments fetched successfully.");
  } catch (error) {
    const errorMessage = error.message || "Something went wrong while fetching payments.";

    dispatch({
      type: FETCH_PAYMENTS_FAILURE,
      payload: errorMessage,
    });

  }
};



// Fetch Payments for Logged-in User (by membershipId)
export const fetchMyPayments = () => async (dispatch) => {
  dispatch({ type: FETCH_MY_PAYMENTS_REQUEST });

  try {
    const membershipId = localStorage.getItem("loggedInUserMembershipId");
    if (!membershipId) throw new Error("Membership Id not found in local storage");

    const response = await api.get(`/PaymentDetail/history/${membershipId}`);

    dispatch({
      type: FETCH_MY_PAYMENTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong while fetching your payments.";

    dispatch({
      type: FETCH_MY_PAYMENTS_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};


// Initiate Payment
export const initiatePayment = (paymentDetailId) => async (dispatch) => {
  dispatch({ type: INITIATE_PAYMENT_REQUEST });
  try {
    const response = await api.post(`/Payment/initiate/${paymentDetailId}`);
    const url = response.data?.redirectUrl; // ✅ use redirectUrl from backend

    dispatch({
      type: INITIATE_PAYMENT_SUCCESS,
      payload: url,
    });

    return url; // return so the component can redirect
  } catch (error) {
    dispatch({
      type: INITIATE_PAYMENT_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};